import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import paymentStripesService from './paymentStripesService';

// Get user from
const initialState = {
  getPaymentStripe: [],
  getPaymentStripeError: false,
  getPaymentStripeSuccess: false,
  paymentStripeLoading: false,
  getPaymentStripeErrorMsg: '',

  addPlanPaymentStripe: '',
  addPlanPaymentStripeError: false,
  addPlanPaymentStripeSuccess: false,
  addPlanpaymentStripeLoading: false,
  addPlanPaymentStripeErrorMsg: '',
  // plans lists
  getPaymentsPlansList: [],
  getPaymentsPalnsListError: false,
  getPaymentsPalnsListsuccess: false,
  getPaymentsPalnsListLoading: false,
  getPaymentsPalnsListErrorMsg: '',
  // recuring checkout
  recurringCheckout: '',
  recurringCheckoutSuccess: '',
  recurringCheckoutError: '',
  recurringCheckoutLoading: '',
  recurringCheckoutErrorMsg: '',
  // create billing data
  getBillingData: [],
  getBillingDataError: false,
  getBillingDataSuccess: false,
  getBillingDataLoading: false,
  getBillingDataErrorMsg: '',

  // getBillingByUserId
  getBillingByUserId: [],
  getBillingByUserIdError: false,
  getBillingByUserIdSuccess: false,
  getBillingByUserIdLoading: false,
  getBillingByUserIdErrorMsg: '',

  // getBillinginfoLastId
  getPaymentsByUserid: [],
  getPaymentsByUserIdError: false,
  getPaymentsByUserIdSuccess: false,
  getPaymentsByUserIdLoading: false,
  getPaymentsByUserIdErrorMsg: '',

  // getBioBlockStatus
  gettBioBlockStatus: [],
  getBioBlockStatusLoading: false,
  getBioBlockStatusSuccess: false,
  getBioBlockStatusError: false,
  getBioBlockStatusErrorMsg: '',
  // getBioBlockStatus
  gettBlockByPlanId: [],
  getBlockByPlanIdLoading: false,
  getBlockByPlanIdSuccess: false,
  getBlockByPlanIdError: false,
  getBlockByPlanIdErrorMsg: '',
  // getAllTaxRate
  getAllTaxesRate: [],
  getAllTaxRateLoading: false,
  getAllTaxRateSuccess: false,
  getAllTaxRateError: false,
  getAllTaxRateErrorMsg: '',
  // getAllTaxRate
  getAllDBCoupon: [],
  getAllDBCouponsLoading: false,
  getAllDBCouponsSuccess: false,
  getAllDBCouponsError: false,
  getAllDBCouponsErrorMsg: '',

  // getAllTaxRate
  getsAllCharges: [],
  getAllChargesLoading: false,
  getAllChargesSuccess: false,
  getAllChargesError: false,
  getAllChargesErrorMsg: '',

  // getAllDBPayments
  getAllDBPayments: [],
  getAllDBPaymentsLoading: false,
  getAllDBPaymentsSuccess: false,
  getAllDBPaymentsError: false,
  getAllDBPaymentsErrorMsg: '',

  // getAllDBCharges
  getAllDBCharges: [],

  // edit plans
  editPlans: '',
  editPlansSuccess: false,
  editPlansError: false,
  editPlansLoading: false,
  editPlansErorMsg: '',

  // delete payment plan
  deletedPlansStatusState: '',
  deletedPlanSuccess: false,
  deletedPlanError: false,
  deletedPlanLoading: false,
  deletedErrorMsg: '',

  // apply Coupoun
  applysCoupoun: '',
  applyCoupounSuccess: false,
  applyCoupounError: false,
  applyCoupounLoading: false,
  applyCoupounErrorMsg: '',
  // getPlanByProductId
  getPlanByProductId: '',
  getPlanByProductIdSuccess: false,
  getPlanByProductIdError: false,
  getPlanByProductIdLoading: false,
  getPlanByProductIdErrorMsg: '',
  // getSingleTaxRate
  getsSingleTaxRate: '',
  getSingleTaxRateSuccess: false,
  getSingleTaxRateError: false,
  getSingleTaxRateLoading: false,
  getSingleTaxRateErrorMsg: '',
  //
  getsStripeSingleCoupon: '',
  getStripeSingleCouponSuccess: false,
  getStripeSingleCouponError: false,
  getStripeSingleCouponLoading: false,
  getStripeSingleCouponErrorMsg: '',
};

// getting____________PaymentStripe____________________
export const gettingPaymentStripes = createAsyncThunk(
  'getStripes/gettingPaymentStripes',

  async (data, thunkAPI) => {
    try {
      const response = await paymentStripesService.paymentsStripe(data);
      return response;
      // getting getlink data from getlink services
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const getPaymentStripeErrorMsg =
        (error.response && error.response.data && error.response.data.getPaymentStripeErrorMsg) ||
        error.getPaymentStripeErrorMsg ||
        error.toString();
      //         if(error.response?.status === 498){
      //           localStorage.clear()
      //           window.location.href = "/auth/login";
      // }
      return thunkAPI.rejectWithValue(getPaymentStripeErrorMsg);
    }
  }
);
export const addPlanStripes = createAsyncThunk(
  'addPlanStripeData/addPlanStripes',

  async (data, thunkAPI) => {
    try {
      const response = await paymentStripesService.addplanStripe(data);
      return response;
      // getting getlink data from getlink services
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const getPaymentStripeErrorMsg =
        (error.response && error.response.data && error.response.data.getBioLinkErrorMsg) ||
        error.getBioLinkErrorMsg ||
        error.toString();
      //         if(error.response?.status === 498){
      //           localStorage.clear()
      //           window.location.href = "/auth/login";
      // }
      return thunkAPI.rejectWithValue(getPaymentStripeErrorMsg);
    }
  }
);
// _______________getting pyaments plans list tunk -----------------
export const gettingPaymentsPalnsList = createAsyncThunk(
  'paymentsPlans/gettingPaymentsPalnsList',
  async (data, thunkAPI) => {
    try {
      return await paymentStripesService.gettingPaymentsPalnsList(data);
    } catch (error) {
      const errorMsg =
        (error.response && error.response.data && error.response.data.getPaymentsPalnsListErrorMsg) ||
        error.getPaymentsPalnsListErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// _______________rucurring chechout -----------------
export const getRecurringCheckout = createAsyncThunk(
  'recurringCheckout/getRecurringCheckout',
  async (state, thunkAPI) => {
    try {
      return await paymentStripesService.getRecurringCheckout(state);
    } catch (error) {
      const errorMsg =
        (error.response && error.response.data && error.response.data.recurringCheckoutErrorMsg) ||
        error.recurringCheckoutErrorMsg ||
        error.toString();
      alert(errorMsg);
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
// _______________ creating Billing Data -----------------
export const getBillingData = createAsyncThunk('getBilling/getBillingData', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.getBillingData(state);
  } catch (error) {
    const errorMsg =
      (error.response && error.response.data && error.response.data.recurringCheckoutErrorMsg) ||
      error.recurringCheckoutErrorMsg ||
      error.toString();
    alert(errorMsg);
    return thunkAPI.rejectWithValue(errorMsg);
  }
});
// _______________ getBillingByUserid -----------------
export const getBillingByUserid = createAsyncThunk('getBillingById/getBillingByUserid', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.getBillingByUserId();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
// _______________ getPaymentsByUserId -----------------
export const getPaymentsByUserId = createAsyncThunk('gettingInfo/getPaymentsByUserId', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.getPaymentsByUserID();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
// _______________ getPaymentsByUserId -----------------
export const getBioBlockStatus = createAsyncThunk('gettingBlockInfo/getBioBlockStatus', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.gettingBioBlockStatus();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
// _______________ getAllDBCoupons -----------------
export const getAllDBCoupons = createAsyncThunk('gettingAllDBCoupons/getAllDBCoupons', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.getAllDBCoupons();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
// _______________ getAllTaxRate -----------------
export const getAllTaxRate = createAsyncThunk('gettingAllTaxes/getAllTaxRate', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.getAllTaxRate();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
// _______________ getBlockByPlanId -----------------
export const getBlockByPlanId = createAsyncThunk('gettingBlockByPlanId/getBlockByPlanId', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.gettingBlockByPlanId();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
// _______________ getAllCharges -----------------
export const getAllCharges = createAsyncThunk('gettingAllCharges/getAllCharges', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.gettingAllCharges(state);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

// editing plans

export const editinPaymentPlans = createAsyncThunk('editingPlans/editinPaymentPlans', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.editinPayments(state);
  } catch (error) {
    const errorMsg =
      (error.response && error.response.data && error.response.data.recurringCheckoutErrorMsg) ||
      error.recurringCheckoutErrorMsg ||
      error.toString();
    alert(errorMsg);
    return thunkAPI.rejectWithValue(errorMsg);
  }
});

// deleting specific plan

export const deletingPaymentPlan = createAsyncThunk('deletePlan/deletingPaymentPlan', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.deletingPaymentPlan(state);
  } catch (error) {
    const errorMsg =
      (error.response && error.response.data && error.response.data.deletedErrorMsg) ||
      error.deletedErrorMsg ||
      error.toString();
    alert(errorMsg);
    return thunkAPI.rejectWithValue(errorMsg);
  }
});
// deleting specific plan

export const applyCoupoun = createAsyncThunk('applyingCoupoun/applyCoupoun', async (state, thunkAPI) => {
  try {
    return await paymentStripesService.applyCoupoun(state);
  } catch (error) {
    const errorMsg =
      (error.response && error.response.data && error.response.data.deletedErrorMsg) ||
      error.deletedErrorMsg ||
      error.toString();
    alert(errorMsg);
    return thunkAPI.rejectWithValue(errorMsg);
  }
});

export const gettingAllDBPayments = createAsyncThunk(
  'getAllDBPayments/gettingAllDBPayments',
  async (state, thunkAPI) => {
    try {
      return await paymentStripesService.getAllDBPayments(state);
    } catch (error) {
      const errorMsg =
        (error.response && error.response.data && error.response.data.getAllDBPaymentsErrorMsg) ||
        error.getAllDBPaymentsErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
export const gettPlanByProductId = createAsyncThunk(
  'gettingPlanByProductId/gettPlanByProductId',
  async (state, thunkAPI) => {
    try {
      return await paymentStripesService.getPlanByProductId(state);
    } catch (error) {
      const errorMsg =
        (error.response && error.response.data && error.response.data.getAllDBPaymentsErrorMsg) ||
        error.getAllDBPaymentsErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
export const getSingleTaxRate = createAsyncThunk(
  'gettingSingleTaxRate/getSingleTaxRate',
  async (taxid, thunkAPI) => {
    try {
      return await paymentStripesService.getSingleTaxRate(taxid);
    } catch (error) {
      const errorMsg =
        (error.response && error.response.data && error.response.data.getAllDBPaymentsErrorMsg) ||
        error.getAllDBPaymentsErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
export const getStripeSingleCoupon = createAsyncThunk(
  'gettingStripeSingleCoupon/getStripeSingleCoupon',
  async (couponid, thunkAPI) => {
    try {
      return await paymentStripesService.getStripeSingleCoupon(couponid);
    } catch (error) {
      const errorMsg =
        (error.response && error.response.data && error.response.data.getAllDBPaymentsErrorMsg) ||
        error.getAllDBPaymentsErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);
export const paymentStripeSlice = createSlice({
  // handle the api response(promise coming from api) , either
  name: 'gettingPaymentStripes',
  initialState,
  reducers: {
    resetAddPaymentUser: (state) => {
      state.addPlanPaymentStripe = [];
      state.addPlanPaymentStripeError = false;
      state.addPlanPaymentStripeSuccess = false;
      state.addPlanpaymentStripeLoading = false;
      state.addPlanPaymentStripeErrorMsg = '';
    },
    resetPaymentUser: (state) => {
      state.getPaymentStripe = [];
      state.getPaymentStripeError = false;
      state.getPaymentStripeSuccess = false;
      state.paymentStripeLoading = false;
      state.getPaymentStripeErrorMsg = '';
    },
    resetRecurringCheckput: (state) => {
      state.recurringCheckout = '';
      state.recurringCheckoutError = false;
      state.recurringCheckoutSuccess = false;
      state.recurringCheckoutLoading = false;
      state.recurringCheckoutErrorMsg = '';
    },
    resetEditPlans: (state) => {
      state.editPlansSuccess = false;
      state.editPlansError = false;
      state.editPlansLoading = false;
      state.editPlansErorMsg = '';
    },
    resetDeletingStates: (state) => {
      state.deletedPlansStatusState = '';
      state.deletedPlanSuccess = false;
      state.deletedPlanError = false;
      state.deletedPlanLoading = false;
      state.deletedErrorMsg = '';
    },
    resetGettingBillingData: (state) => {
      state.getBillingData = [];
      state.getBillingDataError = false;
      state.getBillingDataLoading = false;
      state.getBillingDataSuccess = false;
      state.getBillingDataErrorMsg = '';
    },
    resetgetBillingByUserid: (state) => {
      state.getBillingByUserid = [];
      state.getBillingByUserIdError = false;
      state.getBillingByUserIdLoading = false;
      state.getBillingByUserIdSuccess = false;
      state.getBillingByUserIdErrorMsg = '';
    },
    resetgetPaymentsByUserId: (state) => {
      state.getPaymentsByUserid = [];
      state.getPaymentsByUserIdError = false;
      state.getPaymentsByUserIdLoading = false;
      state.getPaymentsByUserIdSuccess = false;
      state.getPaymentsByUserIdErrorMsg = '';
    },
    resetgetBlockByPlanId: (state) => {
      state.gettBlockByPlanId = [];
      state.getBlockByPlanIdError = false;
      state.getBlockByPlanIdLoading = false;
      state.getBlockByPlanIdSuccess = false;
      state.getBlockByPlanIdErrorMsg = '';
    },
    resetgetPlanByProductId: (state) => {
      state.getPlanByProductIdError = false;
      state.getPlanByProductIdLoading = false;
      state.getPlanByProductIdSuccess = false;
      state.getPlanByProductIdErrorMsg = '';
    },
    resetgetStripeSingleCoupon: (state) => {
      state.getsStripeSingleCoupon=[];
      state.getStripeSingleCouponError = false;
      state.getStripeSingleCouponLoading = false;
      state.getStripeSingleCouponSuccess = false;
      state.getStripeSingleCouponErrorMsg = '';
    },
    resetgetSingleTaxRate: (state) => {
      state.getsSingleTaxRate=[];
      state.getSingleTaxRateError = false;
      state.getSingleTaxRateLoading = false;
      state.getSingleTaxRateSuccess = false;
      state.getSingleTaxRateErrorMsg = '';
    },
    resetapplysCoupoun: (state) => {
      state.applysCoupoun='';
      state.applyCoupounError = false;
      state.applyCoupounLoading = false;
      state.applyCoupounSuccess = false;
      state.applyCoupounErrorMsg = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(gettingPaymentStripes.pending, (state) => {
        state.paymentStripeLoading = true;
      })
      .addCase(gettingPaymentStripes.fulfilled, (state, action) => {
        state.paymentStripeLoading = false;
        state.getPaymentStripeSuccess = true;
        state.getPaymentStripe = action.payload;
      })
      .addCase(gettingPaymentStripes.rejected, (state, action) => {
        state.paymentStripeLoading = false;
        state.getPaymentStripeError = true;
        state.getPaymentStripeErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      .addCase(addPlanStripes.pending, (state) => {
        state.addPlanpaymentStripeLoading = true;
      })
      .addCase(addPlanStripes.fulfilled, (state, action) => {
        state.addPlanpaymentStripeLoading = false;
        state.addPlanPaymentStripeSuccess = true;
        state.addPlanPaymentStripe = action.payload;
      })
      .addCase(addPlanStripes.rejected, (state, action) => {
        state.addPlanpaymentStripeLoading = false;
        state.getPaymentsPalnsListError = true;
        state.addPlanPaymentStripeErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      // _______________getting pyaments plans list cases -----------------

      .addCase(gettingPaymentsPalnsList.pending, (state) => {
        state.getPaymentsPalnsListLoading = true;
      })
      .addCase(gettingPaymentsPalnsList.fulfilled, (state, action) => {
        state.getPaymentsPalnsListLoading = false;
        state.getPaymentsPalnsListsuccess = true;
        state.getPaymentsPlansList = action.payload;
      })
      .addCase(gettingPaymentsPalnsList.rejected, (state, action) => {
        state.getPaymentsPalnsListLoading = false;
        state.addPlanPaymentStripeError = true;
        state.getPaymentsPalnsListErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })

      // recurrring checkout
      .addCase(getRecurringCheckout.pending, (state) => {
        state.recurringCheckoutLoading = true;
      })
      .addCase(getRecurringCheckout.fulfilled, (state, action) => {
        state.recurringCheckoutLoading = false;
        state.recurringCheckoutSuccess = true;
        state.recurringCheckout = action.payload;
      })
      .addCase(getRecurringCheckout.rejected, (state, action) => {
        state.recurringCheckoutLoading = false;
        state.recurringCheckoutError = true;
        state.recurringCheckoutErrorMsg = action.payload;
      })

      // create billing data
      .addCase(getBillingData.pending, (state) => {
        state.getPLansLoading = true;
      })
      .addCase(getBillingData.fulfilled, (state, action) => {
        state.getBillingDataLoading = false;
        state.getBillingDataSuccess = true;
        state.getBillingData = action.payload;
      })
      .addCase(getBillingData.rejected, (state, action) => {
        state.getBillingDataLoading = false;
        state.getBillingDataError = true;
        state.getBillingDataErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })

      // getBillingByUserid
      .addCase(getBillingByUserid.pending, (state) => {
        state.getBillingByUserIdLoading = true;
      })
      .addCase(getBillingByUserid.fulfilled, (state, action) => {
        state.getBillingByUserIdLoading = false;
        state.getBillingByUserIdSuccess = true;
        state.getBillingByUserId = action.payload;
      })
      .addCase(getBillingByUserid.rejected, (state, action) => {
        state.getBillingByUserIdLoading = false;
        state.getBillingByUserIdError = true;
        state.getBillingByUserIdErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      // getPaymentsByUserId
      .addCase(getPaymentsByUserId.pending, (state) => {
        state.getPaymentsByUserIdLoading = true;
      })
      .addCase(getPaymentsByUserId.fulfilled, (state, action) => {
        state.getPaymentsByUserIdLoading = false;
        state.getPaymentsByUserIdSuccess = true;
        state.getPaymentsByUserid = action.payload;
      })
      .addCase(getPaymentsByUserId.rejected, (state, action) => {
        state.getPaymentsByUserIdLoading = false;
        state.getPaymentsByUserIdError = true;
        state.getPaymentsByUserIdErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      // getBioBlockStatus
      .addCase(getBioBlockStatus.pending, (state) => {
        state.getBioBlockStatusLoading = true;
      })
      .addCase(getBioBlockStatus.fulfilled, (state, action) => {
        state.getBioBlockStatusLoading = false;
        state.getBioBlockStatusSuccess = true;
        state.gettBioBlockStatus = action.payload;
      })
      .addCase(getBioBlockStatus.rejected, (state, action) => {
        state.getBioBlockStatusLoading = false;
        state.getBioBlockStatusError = true;
        state.getBioBlockStatusErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      // getBlockByPlanId
      .addCase(getBlockByPlanId.pending, (state) => {
        state.getBlockByPlanIdLoading = true;
      })
      .addCase(getBlockByPlanId.fulfilled, (state, action) => {
        state.getBlockByPlanIdLoading = false;
        state.getBlockByPlanIdSuccess = true;
        state.gettBlockByPlanId = action.payload;
      })
      .addCase(getBlockByPlanId.rejected, (state, action) => {
        state.getBioBlockStatusLoading = false;
        state.getBioBlockStatusError = true;
        state.getBlockByPlanIdErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      // getAllTaxRate
      .addCase(getAllTaxRate.pending, (state) => {
        state.getAllTaxRateLoading = true;
      })
      .addCase(getAllTaxRate.fulfilled, (state, action) => {
        state.getAllTaxRateLoading = false;
        state.getAllTaxRateSuccess = true;
        state.getAllTaxesRate = action.payload;
      })
      .addCase(getAllTaxRate.rejected, (state, action) => {
        state.getAllTaxRateLoading = false;
        state.getAllTaxRateError = true;
        state.getAllTaxRateErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      // getAllDBCoupons
      .addCase(getAllDBCoupons.pending, (state) => {
        state.getAllDBCouponsLoading = true;
      })
      .addCase(getAllDBCoupons.fulfilled, (state, action) => {
        state.getAllDBCouponsLoading = false;
        state.getAllDBCouponsSuccess = true;
        state.getAllDBCoupon = action.payload;
      })
      .addCase(getAllDBCoupons.rejected, (state, action) => {
        state.getAllDBCouponsLoading = false;
        state.getAllDBCouponsError = true;
        state.getAllDBCouponsErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      // getAllCharges
      .addCase(getAllCharges.pending, (state) => {
        state.getAllChargesLoading = true;
      })
      .addCase(getAllCharges.fulfilled, (state, action) => {
        state.getAllChargesLoading = false;
        state.getAllChargesSuccess = true;
        state.getsAllCharges = action.payload;
      })
      .addCase(getAllCharges.rejected, (state, action) => {
        state.getAllChargesLoading = false;
        state.getAllChargesError = true;
        state.getAllChargesErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })
      .addCase(gettingAllDBPayments.pending, (state) => {
        state.getAllDBPaymentsLoading = true;
      })
      .addCase(gettingAllDBPayments.fulfilled, (state, action) => {
        state.getAllDBPaymentsLoading = false;
        state.getAllDBPaymentsSuccess = true;
        state.getAllDBPayments = action.payload;
      })
      .addCase(gettingAllDBPayments.rejected, (state, action) => {
        state.getAllDBPaymentsLoading = false;
        state.getAllDBPaymentsError = true;
        state.getAllDBPaymentsErrorMsg = action.payload; // error from catch will come here via action.payload and update getBioLinkErrorMsg
      })

      // editing plans list
      .addCase(editinPaymentPlans.pending, (state) => {
        state.editPlansLoading = true;
      })
      .addCase(editinPaymentPlans.fulfilled, (state, action) => {
        state.editPlansLoading = false;
        state.editPlansSuccess = true;
        state.editPlans = action.payload;
      })
      .addCase(editinPaymentPlans.rejected, (state, action) => {
        state.editPlansLoading = false;
        state.editPlansError = true;
        state.editPlansErorMsg = action.payload;
      })
      // deleting plan cases
      .addCase(deletingPaymentPlan.pending, (state) => {
        state.deletedPlanLoading = true;
      })
      .addCase(deletingPaymentPlan.fulfilled, (state, action) => {
        state.deletedPlanLoading = false;
        state.deletedPlanSuccess = true;
        state.deletedPlansStatusState = action.payload;
      })
      .addCase(deletingPaymentPlan.rejected, (state, action) => {
        state.deletedPlanLoading = false;
        state.deletedPlanError = true;
        state.deletedErrorMsg = action.payload;
      })
      // applyCoupoun
      .addCase(applyCoupoun.pending, (state) => {
        state.applyCoupounLoading = true;
      })
      .addCase(applyCoupoun.fulfilled, (state, action) => {
        state.applyCoupounLoading = false;
        state.applyCoupounSuccess = true;
        state.applysCoupoun = action.payload;
      })
      .addCase(applyCoupoun.rejected, (state, action) => {
        state.applyCoupounLoading = false;
        state.applyCoupounError = true;
        state.applyCoupounErrorMsg = action.payload;
      })
      // gettPlanByProductId
      .addCase(gettPlanByProductId.pending, (state) => {
        state.getPlanByProductIdLoading = true;
      })
      .addCase(gettPlanByProductId.fulfilled, (state, action) => {
        state.getPlanByProductIdLoading = false;
        state.getPlanByProductIdSuccess = true;
        state.getPlanByProductId = action.payload;
      })
      .addCase(gettPlanByProductId.rejected, (state, action) => {
        state.getPlanByProductIdLoading = false;
        state.getPlanByProductIdError = true;
        state.getPlanByProductIdErrorMsg = action.payload;
      })
      .addCase(getSingleTaxRate.pending, (state) => {
        state.getSingleTaxRateLoading = true;
      })
      .addCase(getSingleTaxRate.fulfilled, (state, action) => {
        state.getSingleTaxRateLoading = false;
        state.getSingleTaxRatedSuccess = true;
        state.getsSingleTaxRate = action.payload;
      })
      .addCase(getSingleTaxRate.rejected, (state, action) => {
        state.getSingleTaxRateLoading = false;
        state.getSingleTaxRateError = true;
        state.getSingleTaxRateErrorMsg = action.payload;
      })
      .addCase(getStripeSingleCoupon.pending, (state) => {
        state.getStripeSingleCouponLoading = true;
      })
      .addCase(getStripeSingleCoupon.fulfilled, (state, action) => {
        state.getStripeSingleCouponLoading = false;
        state.getStripeSingleCouponSuccess = true;
        state.getsStripeSingleCoupon = action.payload;
      })
      .addCase(getStripeSingleCoupon.rejected, (state, action) => {
        state.getStripeSingleCouponLoading = false;
        state.getStripeSingleCouponError = true;
        state.getStripeSingleCouponErrorMsg = action.payload;
      });
  },
});
export const {
  resetPaymentUser,
  resetRecurringCheckput,
  resetAddPaymentUser,
  resetEditPlans,
  resetDeletingStates,
  resetGettingBillingData,
  resetgetPaymentsByUserId,
  resetgetBlockByPlanId,
  resetgetPlanByProductId,
  resetgetStripeSingleCoupon,
  resetgetSingleTaxRate,
  resetapplysCoupoun
} = paymentStripeSlice.actions;
export default paymentStripeSlice.reducer;
